import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

import AppInitializerGuard from '@/components/system/common/AppInitializerGuard';

const MobilePortal = lazy(() => import('@/pages/portal/MobilePortal'));

const mobilePortalRoutes: RouteObject[] = [
  {
    path: '/portal',
    element: (
      <AppInitializerGuard>
        <MobilePortal />
      </AppInitializerGuard>
    )
  }
];

export default mobilePortalRoutes;
